import { ReactElement } from 'react';
import { DisabledFilterTooltip } from './DisabledFilterTooltip';
import { Filter30daysTooltip } from './Filter30DaysTooltip';

interface PeriodPickerTooltipProps {
  disablePeriodPicker?: boolean;
  isLessThan30days?: boolean;
  children: ReactElement;
}

export function PeriodPickerTooltip({
  children,
  disablePeriodPicker,
  isLessThan30days
}: PeriodPickerTooltipProps) {
  if (disablePeriodPicker) {
    return (
      <DisabledFilterTooltip enabled={true}>
        <div>{children}</div>
      </DisabledFilterTooltip>
    );
  } else if (isLessThan30days) {
    return <Filter30daysTooltip>{children}</Filter30daysTooltip>;
  }

  return children;
}
